const tab_sections = {
    overview: 'نظرة عامة',
    authentication: 'المصادقة',
    authorization: 'الترخيص',
    users: 'المستخدمين',
    developer: 'المطور',
    tenant: 'المستأجر',
};
export default Object.freeze(tab_sections);
